module.exports = __webpack_public_path__ + "img/公司荣誉.9c17f19c.svg";